import { Col, Row } from 'reactstrap';
import { matchesSearch } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import { capitalizeFirstLetter } from 'src/utils/string';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import RiscoLookup from 'src/lookups/item';
import GrauRiscoLookup from 'src/lookups/grau-risco';
import DicionarioRiscoLookup from 'src/lookups/DicionarioRiscos/DicionarioRiscoLookup';
import NivelDicionarioRiscoLookup from 'src/lookups/NivelDicionarioRiscoLookup';

const BasicsSection = ({ model, resources, intl, searchQuery }) => {
  const fields = [
    { label: resources?.riscos, id: 'riscos' },
    { label: intl.formatMessage({ id: 'exposicao' }), id: 'exposicao' },
    { label: intl.formatMessage({ id: 'categoria' }), id: 'categoria' },
    { label: intl.formatMessage({ id: 'nivel' }), id: 'nivel' },
  ].filter(Boolean);

  const matchCount = fields.filter((f) =>
    matchesSearch(f.label, searchQuery)
  ).length;

  const visibleFields = fields.filter((f) =>
    matchesSearch(f.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) return null;

  const isVisible = (id) => visibleFields.some((f) => f.id === id);

  return (
    <CollapsibleSection
      title={intl.formatMessage({ id: 'label.informacoesBasicas' })}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {isVisible('riscos') && (
          <Col md={12}>
            <RiscoLookup
              multi
              clearable
              model={{
                label: capitalizeFirstLetter(resources.riscos),
                value: model.getModel('riscos').value,
                requestChange: model.getModel('riscos').requestChange,
              }}
            />
          </Col>
        )}

        {isVisible('exposicao') && (
          <Col md={12}>
            <GrauRiscoLookup
              multi={true}
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'exposicao' })
                ),
                value: model.getModel('exposicao').value,
                requestChange: model.getModel('exposicao').requestChange,
              }}
            />
          </Col>
        )}

        {isVisible('categoria') && (
          <Col md={12}>
            <DicionarioRiscoLookup
              multi
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'categoria' })
                ),
                value: model.getModel('categoriaDicionario').value,
                requestChange: model.getModel('categoriaDicionario')
                  .requestChange,
              }}
              clearable
            />
          </Col>
        )}

        {isVisible('nivel') && (
          <Col md={12}>
            <NivelDicionarioRiscoLookup
              multi
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'nivel' })
                ),
                value: model.getModel('niveis').value,
                requestChange: model.getModel('niveis').requestChange,
              }}
              clearable
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default BasicsSection;
